import Vue from 'vue'
import { Carousel, Slide } from 'vue-carousel';
import axios from 'axios'
import eventHub from '../helpers/event-hub'
import moment from 'moment'

if (document.getElementById('vue-main')) {

  const informations = JSON.parse(document.getElementById('cp_recrutement_json').innerText),
        employer = informations.page_types.find(item => item.value === true),
        candidate = informations.page_types.find(item => item.value === false),
        page_type = informations.page_type,
        main_url_employer = informations.main_url_employer,
        main_url_candidate = informations.main_url_candidate,
        meeting_title = informations.meeting_title,
        meeting_informations = informations.meeting_informations,
        related_page = informations.related_page,
        lang = informations.lang,
        calendly_url = informations.calendly_url,
        meeting_baseline = informations.meeting_baseline;

  new Vue({
    el: '#vue-main',
    data() {
      return {
        dropzoneOptions: {
          url: '/wp-json/api/v1/contact',
          autoProcessQueue: false,
          uploadMultiple: true,
          addRemoveLinks: true,
          parallelUploads: 100,
          maxFiles: 100,
          dictCancelUpload: "Annuler l'upload",
          dictUploadCanceled: "Upload annulé.",
          dictCancelUploadConfirmation: "Êtes-vous sûr de vouloir annuler l'upload ?",
          dictRemoveFile: "Supprimer le fichier",
        },
        tabs: [
          {
            name: 'tab1',
            label: meeting_title,
            icon: 'calendar',
            baseline: meeting_baseline
          }
        ],
        meeting_informations: meeting_informations,
        page_type: page_type,
        loading: true,
        last_posts: [],
        single_last_posts: [],
        recommendations_clients: [],
        recommendations_talents: [],
        recommendations_type: [],
        recommendations: [],
        recommendation_type: {
          value: '',
          checkedLabel: '',
          uncheckedLabel: ''
        },
        posts: [],
        filters: {
          categories: []
        },
        categories: [],
        page: 0,
        totalPages: null,
        change: true,
        checkbox: {
          value: page_type,
          checkedLabel: employer.label,
          uncheckedLabel: candidate.label
        },
        optionsCivilities: [
          {
            value: 'madame',
            label: 'Mme'
          }, {
            value: 'monsieur',
            label: 'M.'
          }
        ],
        optionsSalary: [
          {
            value: 'value_1',
            label: 'Valeur 1'
          }, {
            value: 'value_2',
            label: 'Valeur 2'
          }, {
            value: 'value_3',
            label: 'Valeur 3'
          }
        ],
        dataJob: {
          firstname: '',
          lastname: '',
          email: '',
          phone: '',
          profil_recherche: '',
        },
        dataCandidate: {
          first_name: '',
          last_name: '',
          mail: '',
          phone: '',
          cv: ''
        },
        dataMeeting: {
          company: '',
          first_name: '',
          last_name: '',
          email: '',
          phone: ''
        },
        applicationSent: false,
        jobSent: false,
        errors: [],
        files: [],
        dropzoneFile: {},
        activeTab: 0,
        activeTabModal: 0,
        jobLoading: false
      }
    },
    components: {
      Carousel,
      Slide,
    },
    created () {
      eventHub.$on(`switch`, (event) => {
        console.log(event)
      }),
      eventHub.$on(`header-switch`, (event) => {
        this.checkbox.value = event
      }),
      eventHub.$on(`footer-switch`, (event) => {
        this.checkbox.value = event
      }),
      eventHub.$on(`tabindexchange`, (event) => {
        console.log('tabindexchange', event)
        this.activeTabModal = event
        console.log('activeTabModal', this.activeTabModal)
      })
    },
    computed: {
      firstPost() {
        const posts = [...this.posts]
        return posts.shift()
      },
      rightPosts() {
        const posts = [...this.posts]
        return posts.splice(1, 2)
      },
      shiftPosts() {
        const posts = [...this.posts]
        return posts.splice(3, this.posts.length)
      }
    },
    mounted() {

      this.initParallax()

      if (document.getElementById('vue-last-posts')) {
        this.getLastPosts()
      }
      if (document.getElementById('vue-single-post')) {
        this.getSingleLastPosts()
      }
      if (document.getElementById('vue-blog')) {
        this.getPosts()
        this.getCategories()
      }
      if (document.getElementById('vue-recommendations')) {
        this.getRecommendationsType()
      }
      this.recommendation_type.value = page_type
    },
    filters: {
      formatDate(value) {
        return moment(value).format('DD.MM.YYYY')
      }
    },
    methods: {

      initParallax() {
        const images = document.querySelectorAll(".js-parallax");
        images.forEach(image => {
          new Ukiyo(image, {
            speed: 1,
            scale: 1.3
          });
        });
      },

      onChangeTab(index) {
        console.log(index)
        this.activeTab = index
      },

      onChangeTabModal(index) {
        console.log(index)
        this.activeTabModal = index
      },

      getLastPosts() {
        axios.get('/wp-json/wp/v2/posts', { params: {
            _embed: 1,
            is_candidate: page_type,
            lang: lang
          }
        })
          .then(response => {
            this.last_posts = response.data.slice(0, 3);
          })
      },

      getSingleLastPosts() {
        const id = document.getElementById('vue-single-post').getAttribute('data-id');
        axios.get('/wp-json/wp/v2/posts', { params: {
            _embed: 1,
            is_candidate: page_type,
            lang: lang,
            exclude: id
          }
        })
          .then(response => {
            // console.log(response.data.slice(0, 3))
            this.single_last_posts = response.data.slice(0, 3);
          })
      },

      getRecommendationsType () {
        axios.get('/wp-json/wp/v2/recommendations_type', { params: {
            _embed: 1,
            is_employer: this.recommendation_type.value,
            lang: lang
          }
        })
          .then(response => {
            this.recommendation_type.checkedLabel = response.data[1].name;
            this.recommendation_type.uncheckedLabel = response.data[0].name;
            this.getRecommendations()
          })
      },

      getRecommendations() {
        axios.get('/wp-json/wp/v2/recommendations', {
          params: { _embed: 1, is_employer: !this.recommendation_type.value, lang: lang }
        })
          .then(response => {
            this.recommendations = this.recommendations.concat(response.data);
            this.change = false;
          })
      },

      onChangeRecommendation (event) {
        this.change = true
        this.recommendations = []
        this.recommendation_type.value = event
        this.getRecommendations()
      },

      getPosts(replace = false) {
        const params = this.filters.categories.length > 0 ? {
          categories: this.filters.categories.join(','),
          per_page: 7,
          offset: this.page * 7,
          _embed: 1,
          is_candidate: page_type,
          lang: lang
        } : {
          per_page: 7,
          offset: this.page * 7,
          _embed: 1,
          is_candidate: page_type,
          lang: lang
        }
        axios.get('/wp-json/wp/v2/posts', {
          params: params
        })
          .then(response => {
            this.totalPages = response.headers['x-wp-totalpages']
            this.posts = replace ? response.data : this.posts.concat(response.data);
            this.loading = false
          })
      },

      getCategories() {
        axios.get('/wp-json/wp/v2/categories', { params: {
          _embed: 1,
          lang: lang,
          hide_empty: true
        }
      })
        .then(response => {
          this.categories = this.categories.concat(response.data);
        })
      },

      onChangeCategories(event) {
        this.filters.categories = event
        this.page = 0
        this.getPosts(true)
      },

      getMore() {
        this.page++
        this.getPosts()
      },

      getPostThumbnail(post) {
        return post._embedded['wp:featuredmedia'] ? `background-image: url(${post._embedded['wp:featuredmedia'][0].source_url})` : '';
      },

      onChange(event) {
        eventHub.$emit('main-switch', event);
        let url;
        if (related_page) {
          url = related_page
        } else {
          url = this.checkbox.value === true ?  main_url_candidate : main_url_employer;
        }
        window.open(url, '_self');
      },

      getArrayBufferFromFile(name, value) {
        return new Promise((resolve, reject) => {
          let fr = new FileReader();
          fr.onload = (e) => {
            let result =  fr.result;
            resolve(window.btoa(result));
          }
          fr.readAsBinaryString(value);
        })
      },

      handleCV(cb) {
        this.getArrayBufferFromFile('cv', this.dataCandidate.cv)
        .then(
          arrayBuffer => {
            cb(arrayBuffer);
          },
          failure => {
            console.log(failure);
            cb(null);
          }
        );
      },

      // CANDIDATE FORM
      candidate() {
        this.errors = []
        const formData = new FormData()
        this.handleCV((CVdata) => {
          formData.append('cv_data', CVdata ? CVdata : '')
          Object.keys(this.dataCandidate).forEach((key) => {
            formData.append(key, this.dataCandidate[key])
          })
          axios.post(
            '/wp-json/api/v1/contact',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          )
          .then((response) => {
            this.applicationSent = true
          })
          .catch((error) => {
            this.errors = error.response.data.data.details
          })
        })
      },

      onFileChange(event) {
        this.dataCandidate.cv = event;
      },

      onProjectFileChange(event) {
        this.dataJob.project = event;
      },

      meet() {
        this.errors = []
        axios.post('/wp-json/api/v1/meeting', this.dataMeeting)
        .then((response) => {
          Calendly.initPopupWidget({
            url: calendly_url,
            prefill: {
              firstName: response.data.user.first_name,
              lastName: response.data.user.last_name,
              email: response.data.user.email,
              customAnswers: {
                a1: response.data.user.phone,
                a2: response.data.user.company
              }
            }
          });
          // this.sendMeetingFormToHubspot(response.data.user)
        })
        .catch((error) => {
          this.errors = error.response.data.data.details
        })
      },

      // sendMeetingFormToHubspot(data) {
      //   axios.post('/wp-json/api/v1/meeting/hubspot', data)
      //     .then((response) => {
      //       console.log(response)
      //       // this.sendDataToHubspot(response.data)
      //     })
      //     .catch((error) => {
      //       console.log(error)
      //       // this.errors = error.response.data.data.details
      //     })
      // },

      uploadJobAd() {
        this.jobLoading = true
        const formData = new FormData()
        Object.keys(this.dataJob).forEach((key) => {
          formData.append(key, this.dataJob[key])
        })
        axios.post('/wp-json/api/v1/upload-job-ad', formData)
        .then((response) => {
          this.jobSent = true
          this.jobLoading = false
          // this.getContactByEmail(this.dataJob.email)
        })
        .catch((error) => {
          this.errors = error.response.data.data.details
        })
      },

      // getContactByEmail(email) {
      //   axios.get(`/wp-json/api/v1/contact?email=${email}`)
      //     .then((response) => {
      //       this.associateDealWithContactID(response.data.vid)
      //     })
      //     .catch((error) => {
      //       console.log(error)
      //     })
      // },

      // associateDealWithContactID(id) {
      //   const data = {
      //     associatedVids: id,
      //     pipeline: pipeline,
      //     dealstage: dealstage,
      //     dealname: 'CANDIDATURE - profil-recherche',
      //     date_de_demarrage: this.dataJob.date_de_demarrage,
      //     salaire_fixe_avec_package: this.dataJob.salaire_fixe_avec_package
      //   }
      //   axios.post('/wp-json/api/v1/deals', data)
      //   .then((response) => {
      //     console.log(response)
      //   })
      //   .catch((error) => {
      //     console.log(error)
      //   })
      // },

      closeJobAdModal() {
        eventHub.$emit('modal:employer:close')
      }

      // sendDataToHubspot(data) {
      //   const dataHubspot = {
      //     "fields": [
      //       {
      //         "name": "email",
      //         "value": data.email
      //       },
      //       {
      //         "name": "firstname",
      //         "value": data.first_name
      //       },
      //       {
      //         "name": "lastname",
      //         "value": data.last_name
      //       }
      //     ],
      //   }
      //   axios({
      //     method: 'post',
      //     url: 'https://api.hsforms.com/submissions/v3/integration/secure/submit/26255331/b1de47b7-a9dc-4530-872d-9f1e563d8cdf',
      //     data: dataHubspot,
      //     headers: {
      //       Authorization: `Bearer pat-eu1-6863f807-67b6-4d7a-8c38-b94ad7844971`,
      //       'Content-Type': 'application/json'
      //     }
      //   })
      //   .then((response) => {
      //     console.log(response)
      //   })
      //   .catch((error) => {
      //     console.log(error)
      //   });        
      // }

    }
  })
}